/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneRadioButton from 'base/components/standalone/RadioButton';

export const DynamicStandaloneRadioButton = StandaloneRadioButton;
export type DynamicStandaloneRadioButtonProps = PropsFromComponent<typeof StandaloneRadioButton>;

export const DynamicStandaloneRadioButtonWith = (extras: DynamicStandaloneExtras): typeof StandaloneRadioButton => {
    return function DynamicStandaloneRadioButton(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'RadioButton');
        return <StandaloneRadioButton {...mergeProps({ options: { theme } }, props)} />;
    }
}